// extracted by mini-css-extract-plugin
export default {"shiftedLogo":"P4RK1AB9","mobile":"mobile"};